// Display-only axis helpers. Neither source points nor analysis math are rounded.
export function evolutionChartScale(series, reference, metric) {
  const factor = metric === 'draw' ? 100 : 1;
  const values = [...series,...reference].map(p=>p.value).filter(v=>v!=null && Number.isFinite(v)).map(v=>v*factor);
  if (!values.length) return {minimum:0,maximum:1,ticks:[0,1],factor};
  const low=Math.min(...values), high=Math.max(...values);
  const span=Math.max(high-low, metric==='draw' ? 2 : .2);
  const raw=span*1.2/5, magnitude=10**Math.floor(Math.log10(raw));
  const step=Math.max(.01,[1,2,2.5,5,10].find(n=>n*magnitude>=raw)*magnitude);
  const minimum=Math.floor((low-span*.1)/step)*step;
  const maximum=Math.ceil((high+span*.1)/step)*step;
  const ticks=Array.from({length:Math.round((maximum-minimum)/step)+1},(_,i)=>Number((minimum+i*step).toFixed(10)));
  return {minimum,maximum,ticks,factor};
}
export function seasonEndYear(season) {
  const match=String(season).match(/^(\d{4})\/(\d{2}|\d{4})$/);
  if (!match) return String(season);
  if(match[2].length===4) return match[2];
  let end=Math.floor(Number(match[1])/100)*100+Number(match[2]);
  if(end<Number(match[1]))end+=100;
  return String(end);
}
export function yearTickIndices(points, width) {
  const slots=Math.max(2,Math.floor((width-85)/55));
  const raw=points.length/slots;
  const step=[1,2,5,10,20,50].find(n=>n>=raw) || Math.ceil(raw);
  return points.map((p,i)=>({i,year:Number(seasonEndYear(p.season))}))
    .filter(p=>Number.isFinite(p.year) && p.year%step===0).map(p=>p.i);
}
